import React from 'react';
import { Link } from 'gatsby';

const LinkButton = ({ to, label }) => {
  return (
    <Link
      className='my-4 cursor-pointer rounded bg-primary px-4 py-3 font-semibold text-white shadow-lg transition duration-200 ease-in-out hover:bg-hover hover:shadow-xl md:px-8 md:py-3 md:text-lg'
      to={to}
    >
      {label}
    </Link>
  );
};

export default LinkButton;
